import { defineStore } from "pinia";
import ResourcesApi from "../api/resourcesApi";
const SESSION_ITEM_ORGANIZATIONS = "organizations";
export const useListOfValuesStore = defineStore("listOfValues", {
  state: () => ({
    divisions: [
      { text: "I", value: 1 },
      { text: "II", value: 2 },
      { text: "III", value: 3 },
    ],
    sports: [
      { text: "Men's Tennis", value: "MTE" },
      { text: "Women's Tennis", value: "WTE" },
    ],
    organizations:
      JSON.parse(sessionStorage.getItem(SESSION_ITEM_ORGANIZATIONS)) || [],
  }),
  getters: {
    getDivisionText: (state) => (val) =>
      state.divisions.find((div) => div.value === val).text,
    getSportText: (state) => (val) =>
      state.sports.find((sport) => sport.value === val).text,
    organizationOptions: (state) => {
      if (state.organizations && state.organizations.length > 0) {
        return state.organizations
          .filter((org) => !org.nameOfficial.includes("CA Test"))
          .map((org) => {
            return { text: org.nameOfficial, value: org.orgId };
          });
      } else {
        return [];
      }
    },
  },
  actions: {
    async fetchOrganizations() {
      if (!this.organizations || this.organizations.length === 0) {
        ResourcesApi.getOrgs().then(
          (response) => (this.organizations = response)
        );
      }
    },
  },
});
